export const appsCatalogsDatatable = "/apps/catalogs_datatable";
